import { useContext, useMemo } from "react";
import { ProjectContext } from "context/ProjectProvider";
import { useCIQQuery } from "hooks/ciq-gql-hooks";
import { QUERY_GET_MILESTONE_NAMES } from "services/graphQL/queries";

type MilestoneNameRow = { name: string };

/**
 * Distinct project template milestone names for a feature, for CF Status dropdowns.
 */
export const useStatusMilestoneNameOptions = (
  featureId: number,
  skip = false
) => {
  const { gqlClientForProject } = useContext(ProjectContext);

  const { data } = useCIQQuery<{
    project_template_milestones: MilestoneNameRow[];
  }>(QUERY_GET_MILESTONE_NAMES, {
    client: gqlClientForProject,
    skip: skip || !gqlClientForProject,
    variables: { feature_id: featureId }
  });

  return useMemo(() => {
    const names = new Set<string>(["Not Started"]);
    for (const milestone of data?.project_template_milestones ?? []) {
      const name = milestone?.name?.trim?.();
      if (name) names.add(name);
    }
    return Array.from(names).sort((a, b) =>
      a.localeCompare(b, undefined, { sensitivity: "base" })
    );
  }, [data?.project_template_milestones]);
};
